<template>
  <div
    class="c-gdpr"
    :class="{ _show: isShow, _notTransition: isNotFirstAccess }"
  >
    <div class="c-gdpr__inner">
      <div class="c-gdpr__contents">
        <p class="c-gdpr__text">
          <slot name="text"></slot>
        </p>
      </div>
      <div class="c-buttonWrap">
        <button class="c-button" lang="en" @click="agreeCookie">
          <span><slot name="button"></slot></span>
        </button>
      </div>
      <button class="c-gdpr__button" @click="hiddenContent" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gdpr',
  data() {
    return {
      isNotFirstAccess: false,
      isShow: true,
    };
  },
  mounted() {
    if (document.cookie.indexOf('showGdpr=false') !== -1) {
      // 2回目以降のアクセス時
      this.isNotFirstAccess = true;
      this.isShow = false;
    }
  },
  methods: {
    agreeCookie() {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      document.cookie = `showGdpr=false; expires=${date.toUTCString()};`;
      this.hiddenContent();
    },
    hiddenContent() {
      this.isShow = false;
    },
  },
};
</script>
